import { observer } from 'mobx-react-lite'
import { EnrolmentStep } from 'widgets/ContactEnrollment'
import type { SurveyEnrollContactsStore } from 'pages/surveys/ui/SurveyView/ui/SurveyEnrollContacts/store/surveyEnrollContactsStore'

type ISurveyEnrollContactsProps = {
  store: SurveyEnrollContactsStore
}

export const SurveyEnrollContacts = observer(({ store }: ISurveyEnrollContactsProps) => {
  const {
    editEnrollment,
    error,
    loading,
    setError,
    enrollmentFilters,
    // SWC-19329: uncomment together with contactReEnroll below
    // enrollmentStore,
    numberStore,
  } = store

  const handleClick = () => {
    if (loading) return
    setError('')
    editEnrollment()
  }

  return (
    <EnrolmentStep
      onClick={handleClick}
      error={error}
      enrollmentFilters={enrollmentFilters}
      errorPlacement='right'
      tooltipLabel={[
        'Select the conditions to enroll contacts',
        <br key='br' />,
        ' in your survey',
      ]}
      title='Contact enrollment'
      numberStore={numberStore}
      dropdownWidth={464}
      // SWC-19329: reenroll toggle is temporarily hidden, uncomment it in one of the next releases
      // contactReEnroll={{
      //   value: enrollmentStore.isContactReEnroll,
      //   onChange: enrollmentStore.setIsContactReEnroll,
      //   isShowAlert: enrollmentStore.isShowContactsAlert,
      //   onCloseAlert: () => enrollmentStore.setIsShowContactsAlert(false),
      // }}
    />
  )
})
